<template>
  <div class="page-tower" :style="{ height: pageHeight + 'px' }">
    <!-- 楼 -->
    <div class="tower">
      <div class="tower-header"></div>
      <div class="tower-title">楼</div>
      <el-scrollbar style="height: 100%">
        <div class="tower-list-box">
          <div
            class="tower-list"
            :class="currTowerIndex == index ? 'tower-list-gray' : ''"
            v-for="(item, index) in towerList"
            :key="index"
          >
            <img :src="editImg" @click="editTower(item)" />
            <!-- <el-input
              v-model="item.name"
              v-if="!item.editing"
              disabled
              @click.native="selectTower(item, index)"
            ></el-input> -->
            <div v-if="!item.editing" @click="selectTower(item, index)">{{item.name}}</div>
            <el-input
              v-model="item.name"
              v-if="item.editing"
              v-focus
            ></el-input>
            <img :src="delImg" @click="delTower(item)" />
          </div>
          <div class="add-box" @click="addTower" v-if="!isAddTower">
            <img :src="addImg" />添加楼
          </div>
          <div class="add-box" v-if="isAddTower">
            <div class="add-name">名称：</div>
            <el-input v-model="addTowerName" v-focus></el-input>
          </div>
        </div>
      </el-scrollbar>
      <hm-button @click="towerFinish">完成</hm-button>
    </div>

    <!-- 层 -->
    <div class="tower">
      <div class="tower-header"></div>
      <div class="tower-title">层</div>
      <el-scrollbar style="height: 100%">
        <div class="tower-list-box">
          <div
            class="tower-list"
            :class="index == currentFloorIndex ? 'tower-list-gray' : ''"
            v-for="(item, index) in floorList"
            :key="index"
          >
            <img :src="editImg" @click="editFloor(item)" />
            <!-- <el-input
              v-model="item.name"
              v-if="!item.editing"
              disabled
              @click.native="selectFloor(item, index)"
            ></el-input> -->
            <div v-if="!item.editing" @click="selectFloor(item, index)">{{item.name}}</div>
            <el-input
              v-model="item.name"
              v-if="item.editing"
              v-focus
            ></el-input>
            <img :src="delImg" @click="delFloor(item)" />
          </div>

          <div class="add-box" @click="addFloor" v-if="!isAddFloor">
            <img :src="addImg" />添加层
          </div>
          <div class="add-box" v-if="isAddFloor">
            <div class="add-name">名称：</div>
            <el-input v-model="addFloorName" v-focus></el-input>
          </div>
        </div>
      </el-scrollbar>
      <hm-button @click="floorFinish">完成</hm-button>
    </div>

    <!-- 房间 -->
    <div class="tower">
      <div class="tower-header"></div>
      <div class="tower-title">房间</div>
      <el-scrollbar style="height: 100%">
        <div class="tower-list-box">
          <div
            class="tower-list"
            :class="index == currentRoomIndex ? 'tower-list-gray' : ''"
            v-for="(item, index) in roomList"
            :key="index"
          >
            <img :src="editImg" @click="editRoom(item)" />
            <!-- <el-input
              v-model="item.name"
              v-if="!item.editing"
              disabled
              @click.native="selectRoom(item, index)"
            ></el-input> -->
            <div v-if="!item.editing" @click="selectRoom(item, index)">{{item.name}}</div>
            <el-input
              v-model="item.name"
              v-if="item.editing"
              v-focus
            ></el-input>
            <img :src="delImg" @click="delRoom(item)" />
          </div>

          <div class="add-box" @click="addRoom" v-if="!isAddRoom">
            <img :src="addImg" />添加房间
          </div>
          <div class="add-box" v-if="isAddRoom">
            <div class="add-name">名称：</div>
            <el-input v-model="addRoomName" v-focus></el-input>
          </div>
        </div>
      </el-scrollbar>
      <hm-button @click="roomFinish">完成</hm-button>
    </div>

    <!-- 位置 -->
    <div class="tower">
      <div class="tower-header"></div>
      <div class="tower-title">位置</div>
      <el-scrollbar style="height: 100%">
        <div class="tower-list-box">
          <div class="tower-list" v-for="(item, index) in bedList" :key="index">
            <img :src="editImg" @click="editBed(item)" />
            <!-- <el-input
              v-model="item.name"
              v-if="!item.editing"
              disabled
            ></el-input> -->
            <div v-if="!item.editing">{{item.name}}</div>
            <el-input
              v-model="item.name"
              v-if="item.editing"
              v-focus
            ></el-input>
            <img :src="delImg" @click="delBed(item)" />
          </div>

          <div class="add-box" @click="addBed" v-if="!isAddBed">
            <img :src="addImg" />添加位置
          </div>
          <div class="add-box" v-if="isAddBed">
            <div class="add-name">名称：</div>
            <el-input v-model="addBedName" v-focus></el-input>
          </div>
        </div>
      </el-scrollbar>
      <hm-button @click="bedFinish">完成</hm-button>
    </div>
  </div>
</template>

<script>
import {
  getBuilding,
  addBuilding,
  updateBuilding,
  delBuilding,
  getFloor,
  addFloor,
  updateFloor,
  delFloor,
  getRoom,
  addRoom,
  updateRoom,
  delRoom,
  addBed,
  getBed,
  delBed,
  updateBed,
} from "../../api/device";
export default {
  name: "Tower",
  data() {
    return {
      pageHeight: 0,
      editImg: require("../../assets/images/main/editTower.svg"),
      delImg: require("../../assets/images/main/delTower.svg"),
      addImg: require("../../assets/images/main/addTower.svg"),

      towerList: [],
      isAddTower: false,
      addTowerName: "",
      isEditTower: false,
      editTowerId: "",
      currTowerId: "",
      currTowerIndex: 0,

      floorList: [],
      isAddFloor: false,
      addFloorName: "",
      isEditFloor: false,
      editFloorId: "",
      currFloorId: "",
      currentFloorIndex: 0,

      roomList: [],
      isAddRoom: false,
      addRoomName: "",
      isEditRoom: false,
      editRoomId: "",
      currRoomId: "",
      currentRoomIndex: 0,

      bedList: [],
      isAddBed: false,
      addBedName: "",
      isEditBed: false,
      editBedId: "",
    };
  },
  created() {
    this.initPageHeight();
    window.addEventListener("resize", this.initPageHeight, false);

    this.queryTower();
  },
  mounted() {},
  computed: {},
  methods: {
    initPageHeight() {
      this.pageHeight = window.innerHeight - 80;
    },

    // 获取楼
    queryTower() {
      getBuilding({
        page: 1,
        size: 9999,
      }).then((res) => {
        console.log("获取楼", res);
        this.towerList = res.data.items;

        if (this.towerList.length > 0) {
          this.towerList.forEach((item, index) => {
            if (index == this.currTowerIndex) {
              this.currTowerId = item.id;
            }
            item.editing = false;
          });
        }

        this.queryFloor();
      });
    },

    // 添加楼
    addTower() {
      this.isAddTower = true;
      this.isEditTower = false;
      if (this.towerList.length > 0) {
        this.towerList.forEach((item) => {
          item.editing = false;
        });
      }
    },

    // 楼完成
    towerFinish() {
      // 判断添加楼、编辑楼
      if (this.isAddTower) {
        if (this.addTowerName == "") {
          this.$message("楼名称不能为空");
        } else {
          addBuilding({
            name: this.addTowerName,
          }).then((res) => {
            this.isAddTower = false;
            this.addTowerName = "";
            this.queryTower();
            this.$message({
              type: "success",
              message: "添加成功！",
            });
          });
        }
      } else if (this.isEditTower) {
        let name = "";
        this.towerList.forEach((item) => {
          if (item.id == this.editTowerId) {
            name = item.name;
          }
        });
        if (name == "") {
          this.$message("楼名称不能为空");
        } else {
          updateBuilding({
            id: this.editTowerId,
            name: name,
          }).then((res) => {
            this.isEditTower = false;
            this.editTowerId = "";
            this.towerList.forEach((item) => {
              item.editing = false;
            });
            this.queryTower();
            this.$message({
              type: "success",
              message: "编辑成功！",
            });
          });
        }
      }
    },

    // 编辑楼
    editTower(data) {
      this.isAddTower = false;
      this.towerList.forEach((item) => {
        item.editing = false;
      });
      this.isEditTower = true;
      this.editTowerId = data.id;
      data.editing = true;

      let list = JSON.parse(JSON.stringify(this.towerList));

      this.towerList = list;
    },

    // 删除楼
    delTower(data) {
      this.$confirm("此操作将删除该楼, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delBuilding({
            ids: [data.id],
          }).then((res) => {
            this.queryTower();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 选择楼
    selectTower(data, index) {
      this.currTowerId = data.id;
      this.currTowerIndex = index;

      this.currentFloorIndex = 0;
      this.currentRoomIndex = 0;
      this.queryFloor();
    },

    // 查询层
    queryFloor() {
      getFloor({
        page: 1,
        size: 9999,
      }).then((res) => {
        console.log("查询楼层", res);
        this.floorList = res.data.items;

        let list = [];
        if (this.floorList.length > 0) {
          this.floorList.forEach((item) => {
            if (item.buildingId == this.currTowerId) {
              list.push(item);
            }
          });
        }
        this.floorList = list;

        if (this.floorList.length > 0) {
          this.floorList.forEach((item, index) => {
            item.editing = false;
            if (index == this.currentFloorIndex) {
              this.currFloorId = item.id;
            }
          });
        }

        this.queryRoom();
      });
    },

    // 添加层
    addFloor() {
      this.isAddFloor = true;
      this.isEditFloor = false;

      if (this.floorList.length > 0) {
        this.floorList.forEach((item) => {
          item.editing = false;
        });
      }
    },

    // 层完成
    floorFinish() {
      // 判断添加层、编辑层
      if (this.isAddFloor) {
        if (this.addFloorName == "") {
          this.$message("层名称不能为空");
        } else {
          addFloor({
            name: this.addFloorName,
            buildingId: this.currTowerId,
          }).then((res) => {
            this.isAddFloor = false;
            this.addFloorName = "";
            this.queryFloor();
            this.$message({
              type: "success",
              message: "添加成功！",
            });
          });
        }
      } else if (this.isEditFloor) {
        let name = "";
        this.floorList.forEach((item) => {
          if (item.id == this.editFloorId) {
            name = item.name;
          }
        });
        if (name == "") {
          this.$message("层名称不能为空");
        } else {
          updateFloor({
            id: this.editFloorId,
            name: name,
            buildingId: this.currTowerId,
          }).then((res) => {
            this.isEditFloor = false;
            this.editFloorId = "";
            this.floorList.forEach((item) => {
              item.editing = false;
            });
            this.queryFloor();
            this.$message({
              type: "success",
              message: "编辑成功！",
            });
          });
        }
      }
    },

    // 编辑层
    editFloor(data) {
      this.isAddFloor = false;
      this.floorList.forEach((item) => {
        item.editing = false;
      });
      this.isEditFloor = true;
      this.editFloorId = data.id;
      data.editing = true;

      let list = JSON.parse(JSON.stringify(this.floorList));

      this.floorList = list;
    },

    // 删除层
    delFloor(data) {
      this.$confirm("此操作将删除该层, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delFloor({
            ids: [data.id],
          }).then((res) => {
            console.log("删除该层", res);
            this.queryFloor();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 选择层
    selectFloor(data, index) {
      this.currFloorId = data.id;
      this.currentFloorIndex = index;

      this.currentRoomIndex = 0;
      this.queryRoom();
    },

    // 查询房
    queryRoom() {
      getRoom({
        page: 1,
        size: 9999,
      }).then((res) => {
        console.log("查询房", res);
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            if (
              item.buildingId == this.currTowerId &&
              item.floorId == this.currFloorId
            ) {
              list.push(item);
            }
          });
        }
        this.roomList = list;

        if (this.roomList.length > 0) {
          this.roomList.forEach((item, index) => {
            item.editing = false;
            if (index == this.currentRoomIndex) {
              this.currRoomId = item.id;
            }
          });
        }

        this.queryBed();
      });
    },

    // 添加房
    addRoom() {
      this.isAddRoom = true;
      this.isEditRoom = false;

      if (this.roomList.length > 0) {
        this.roomList.forEach((item) => {
          item.editing = false;
        });
      }
    },

    // 房完成
    roomFinish() {
      // 判断添加房、编辑房
      if (this.isAddRoom) {
        if (this.addRoomName == "") {
          this.$message("房名称不能为空");
        } else {
          addRoom({
            floorId: this.currFloorId,
            name: this.addRoomName,
          }).then((res) => {
            this.isAddRoom = false;
            this.addRoomName = "";
            this.queryRoom();
            this.$message({
              type: "success",
              message: "添加成功！",
            });
          });
        }
      } else if (this.isEditRoom) {
        let name = "";
        this.roomList.forEach((item) => {
          if (item.id == this.editRoomId) {
            name = item.name;
          }
        });
        if (name == "") {
          this.$message("房名称不能为空");
        } else {
          updateRoom({
            id: this.editRoomId,
            floorId: this.currFloorId,
            name: name,
          }).then((res) => {
            this.isEditRoom = false;
            this.editRoomId = "";
            this.roomList.forEach((item) => {
              item.editing = false;
            });
            this.queryRoom();
            this.$message({
              type: "success",
              message: "编辑成功！",
            });
          });
        }
      }
    },

    // 编辑房
    editRoom(data) {
      this.isAddRoom = false;
      this.roomList.forEach((item) => {
        item.editing = false;
      });
      this.isEditRoom = true;
      this.editRoomId = data.id;
      data.editing = true;

      let list = JSON.parse(JSON.stringify(this.roomList));

      this.roomList = list;
    },

    // 删除房
    delRoom(data) {
      this.$confirm("此操作将删除该房, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delRoom({
            ids: [data.id],
          }).then((res) => {
            this.queryRoom();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 选择房
    selectRoom(data, index) {
      this.currRoomId = data.id;
      this.currentRoomIndex = index;
      this.queryBed();
    },

    // 查询床
    queryBed() {
      getBed({
        page: 1,
        size: 9999,
      }).then((res) => {
        console.log("查询床", res);
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            if (
              item.buildingId == this.currTowerId &&
              item.floorId == this.currFloorId &&
              item.roomId == this.currRoomId
            ) {
              list.push(item);
            }
          });
        }
        this.bedList = list;

        if (this.bedList.length > 0) {
          this.bedList.forEach((item) => {
            item.editing = false;
          });
        }
      });
    },

    // 添加床
    addBed() {
      this.isAddBed = true;
      this.isEditBed = false;

      if (this.bedList.length > 0) {
        this.bedList.forEach((item) => {
          item.editing = false;
        });
      }
    },

    // 床完成
    bedFinish() {
      // 判断添加位置、编辑位置
      if (this.isAddBed) {
        if (this.addBedName == "") {
          this.$message("位置名称不能为空");
        } else {
          addBed({
            roomId: this.currRoomId,
            name: this.addBedName,
            startTime: "00:00:00",
            endTime: "23:59:59",
          }).then((res) => {
            this.isAddBed = false;
            this.addBedName = "";
            this.queryBed();
            this.$message({
              type: "success",
              message: "添加成功！",
            });
          });
        }
      } else if (this.isEditBed) {
        let name = "";
        this.bedList.forEach((item) => {
          if (item.id == this.editBedId) {
            name = item.name;
          }
        });
        if (name == "") {
          this.$message("位置名称不能为空");
        } else {
          updateBed({
            id: this.editBedId,
            name: name,
            roomId: this.currRoomId,
            startTime: "00:00:00",
            endTime: "23:59:59",
          }).then((res) => {
            this.isEditBed = false;
            this.editBedId = "";
            this.bedList.forEach((item) => {
              item.editing = false;
            });
            this.queryBed();
            this.$message({
              type: "success",
              message: "编辑成功！",
            });
          });
        }
      }
    },

    // 编辑床
    editBed(data) {
      this.isAddBed = false;
      this.bedList.forEach((item) => {
        item.editing = false;
      });
      this.isEditBed = true;
      this.editBedId = data.id;
      data.editing = true;

      let list = JSON.parse(JSON.stringify(this.bedList));

      this.bedList = list;
    },

    // 删除床
    delBed(data) {
      this.$confirm("此操作将删除该位置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delBed({
            ids: [data.id],
          }).then((res) => {
            this.queryBed();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 导出表格
    export2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../vendor/Export2Excel");
        let tHeader, filterVal, list;
        switch (this.radio) {
          case "tower":
            tHeader = ["楼编号", "楼名称"];
            filterVal = ["id", "name"];
            list = this.towerList;
            break;
          case "floor":
            tHeader = ["层编号", "层名称", "所属楼"];
            filterVal = ["id", "name", "buildingName"];
            list = this.floorList;
            break;
          case "room":
            tHeader = ["房编号", "房名称", "所属楼", "所属层"];
            filterVal = ["id", "name", "buildingName", "floorName"];
            list = this.roomList;
            break;
          case "bed":
            tHeader = [
              "床编号",
              "床名称",
              "所属楼",
              "所属层",
              "所属房",
              "监控时间段",
            ];
            filterVal = [
              "id",
              "name",
              "buildingName",
              "floorName",
              "roomName",
              '"startTime"+-+"endTime"',
            ];
            list = this.bedList;
            break;
          default:
            break;
        }
        // const tHeader = [
        //   "设备编号",
        //   "设备名称",
        //   "ip",
        //   "端口号",
        //   "关联床位"
        // ];
        // const filterVal = [
        //   "id",
        //   "name",
        //   "ip",
        //   "port",
        //   "bedId"
        // ];
        // const list = this.deviceList;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "列表excel");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initPageHeight, false);
  },
  watch: {},
};
</script>

<style scoped lang='less'>
.page-tower {
  width: 100%;
  padding: 78.5px 80px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  .tower {
    width: 307.5px;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .tower-header {
      width: 100%;
      height: 6px;
      background: #1d63fd;
    }

    .tower-title {
      height: 80px;
      line-height: 80px;
      text-align: center;
      color: #26415f;
      font-size: 24px;
    }
    .tower-list-box {
      width: 100%;
      flex: 1;

      .tower-list {
        width: 250px;
        height: 50px;
        margin: 0 auto;
        color: #1d63fd;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          padding: 0 20px;
          cursor: pointer;
        }
      }

      .tower-list-gray {
        background: #efefef;
      }
    }
    .add-box {
      width: 250px;
      height: 50px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        padding: 0 20px;
      }

      .add-name {
        min-width: 50px;
      }
    }
  }
}
</style>
<style>
.page-tower .is-disabled .el-input__inner {
  background: none;
  border: none;
  color: #1d63fd;
  cursor: pointer;
}
.page-tower .el-input__inner {
  color: #1d63fd;
  border: none;
  background: none;
  padding: 0;
  text-align: center;
}
.page-tower .el-button {
  width: 133px;
  height: 40px;
  margin: 20px auto;
}
.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
}
.el-cascader-menu__wrap {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/system/tower.vue